const collator = Intl.DateTimeFormat("es-ES", { year: "numeric", month: "long", day: "numeric" });
const shortCollator = Intl.DateTimeFormat("es-ES", { year: "numeric", month: "numeric", day: "numeric" });

export const titloIte = (date: Date, tipo: string, style = "long") => {
	return `${(style === "short" ? shortCollator : collator).format(date)} - ITE ${tipo}`;
};
